import { jsx as _jsx } from "react/jsx-runtime";
export const Check = ({ size = '12' }) => {
    return (_jsx("svg", { width: size, height: size, fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", children: _jsx("path", { d: "M20.933 5.187 8.875 17.464 3.067 11.55a.616.616 0 0 0-.884 0 .644.644 0 0 0 0 .9l6.25 6.364a.618.618 0 0 0 .884 0l12.5-12.728a.644.644 0 0 0 0-.9.616.616 0 0 0-.884 0Z", fill: "currentColor" }) }));
};
